import type { ApiInvite } from '#/api/invite/types/ApiInvite';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  invite: ApiInvite;
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  hook: Record<string, any>;
};

export function InviteMessage({ invite, hook }: Props) {
  const { i18n } = useI18n();

  switch (hook.hookType) {
    case 'PROMOTE_TO_ADMIN':
      return (
        <div>
          {i18n(
            '%(inviter)s has invited you to become an administrator of {{strong}}%(name)s{{/strong}}.',
            {
              inviter: invite.byUser.name,
              name: hook.organization?.name ?? '',
              strong: <strong />,
            },
          )}
        </div>
      );

    case 'PROMOTE_TO_OWNER':
      return (
        <div>
          {i18n(
            '%(inviter)s has invited you to become an owner of {{strong}}%(name)s{{/strong}}.',
            {
              inviter: invite.byUser.name,
              name: hook.organization?.name ?? '',
              strong: <strong />,
            },
          )}
        </div>
      );

    default:
      throw new Error('invalid hook type');
  }
}
